export enum InsumoProveedorStockEstado {
  Borrador,
  Vencido,
  Agotado,
  EnStock,
}

export const InsumoProveedorStockEstadoLabels: {
  [key in InsumoProveedorStockEstado]: string;
} = {
  [InsumoProveedorStockEstado.Borrador]: 'Borrador',
  [InsumoProveedorStockEstado.Vencido]: 'Vencido',
  [InsumoProveedorStockEstado.Agotado]: 'Agotado',
  [InsumoProveedorStockEstado.EnStock]: 'EnStock',
};

export const getInsumoProveedorStockEstado = () => {
  return Object.values(InsumoProveedorStockEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: InsumoProveedorStockEstadoLabels[id as InsumoProveedorStockEstado],
    }));
};

export const colorMapping: { [key in InsumoProveedorStockEstado]: string } = {
  [InsumoProveedorStockEstado.Borrador]: '#70BDFF',
  [InsumoProveedorStockEstado.Vencido]: '#212B36',
  [InsumoProveedorStockEstado.Agotado]: '#FF0000',
  [InsumoProveedorStockEstado.EnStock]: '#22c55e',
};
